const API_URL = "https://app.tavad.com/hce/wp-json/tavad/v2/listados";

export async function getListado(
  listadoFechaIni,
  listadoFechaFin,
  listadoFechaIniTrat,
  listadoFechaFinTrat,
  listadoTipoContString,
  listadoEspecialistasString
  ) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}?startdate=${listadoFechaIni}&enddate=${listadoFechaFin}&startdatetrat=${listadoFechaIniTrat}&enddatetrat=${listadoFechaFinTrat}&tipocont=${listadoTipoContString}&responsable=${listadoEspecialistasString}`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    console.log(data);
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getListadoItem(
  listadoFechaIni,
  listadoFechaFin,
  // listadoFechaIniTrat,
  // listadoFechaFinTrat,
  listadoTipoContString,
  listadoEspecialistasString
  ) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`https://app.tavad.com/hce/wp-json/tavad/v2/listado-item?startdate=${listadoFechaIni}&enddate=${listadoFechaFin}&tipocont=${listadoTipoContString}&responsable=${listadoEspecialistasString}`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    console.log(data);
    return data;
  } catch (error) {
    console.error(error);
  }
}


export async function getListadoTratamientos(
  listadoFechaIniTrat,
  listadoFechaFinTrat
  ) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`https://app.tavad.com/hce/wp-json/tavad/v2/listado-tratamientos?startdatetrat=${listadoFechaIniTrat}&enddatetrat=${listadoFechaFinTrat}`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    console.log(data);
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getListadoPacientes(
  ) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`https://app.tavad.com/hce/wp-json/tavad/v2/listado-pacientes`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    console.log(data);
    return data;
  } catch (error) {
    console.error(error);
  }
}